import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Check } from 'lucide-react';

const OptionsSummary = ({ optionsData, showEditButton, editButtonText, editRoute }) => {
  const navigate = useNavigate();
  
  const optionsConfig = {
    coup_envoi: { name: 'Coup d\'envoi', price: 900 },
    diagnostic_individuel: { name: 'Diagnostic individuel', price: 900, unit: '/ apprenant' },
    esprit_equipe: { name: 'Esprit d\'équipe', price: 3500 },
    sortir_du_bois: { name: 'Sortir du bois', price: 1500 },
    panorama_flash: { name: 'Panorama flash', price: 250, unit: '/ module' }
  };

  const selectedOptions = [];
  
  Object.entries(optionsData).forEach(([key, value]) => {
    if (key === 'diagnostic_individuel' && value > 0) {
      selectedOptions.push({
        name: optionsConfig[key].name,
        quantity: value,
        unit: optionsConfig[key].unit
      });
    } else if (key === 'panorama_flash' && value > 0) {
      selectedOptions.push({
        name: optionsConfig[key].name,
        quantity: value,
        unit: optionsConfig[key].unit
      });
    } else if (value === true) {
      selectedOptions.push({
        name: optionsConfig[key].name,
        quantity: 1
      });
    }
  });

  return (
    <div className="summary-box" data-testid="options-summary">
      <h4 className="font-semibold mb-4 text-[#2d2d2d]">Options sélectionnées</h4>
      
      {selectedOptions.length === 0 ? (
        <p className="text-[#647687] italic">Aucune option sélectionnée</p>
      ) : (
        <div className="space-y-3">
          {selectedOptions.map((option, index) => (
            <div key={index} className="flex items-center gap-3 p-3 bg-[#fff5ee] border border-[#fa6800] rounded">
              <div className="w-6 h-6 bg-[#fa6800] rounded-full flex items-center justify-center flex-shrink-0">
                <Check size={16} className="text-white" />
              </div>
              <div className="flex-1">
                <span className="font-medium text-[#2d2d2d]">{option.name}</span>
                {option.quantity > 1 && (
                  <span className="ml-2 text-[#647687] text-sm">
                    (× {option.quantity}{option.unit || ''})
                  </span>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
      
      {showEditButton && (
        <div className="mt-auto pt-4">
          <button
            onClick={() => navigate(editRoute)}
            className="btn-secondary w-full"
            data-testid="edit-options-button"
          >
            {editButtonText}
          </button>
        </div>
      )}
    </div>
  );
};

export default OptionsSummary;